export function removeVNAccents(str: string) {
  return str
    .normalize('NFD') // Chuyển đổi thành Unicode Decomposed
    .replace(/[\u0300-\u036f]/g, ''); // Loại bỏ các ký tự dấu
}

// Hàm giúp tìm kiếm không cần gõ chính xác chữ tiếng Việt vẫn ra kết quả
// Tìm kiếm cả label và value
export function customFilterOption(input: string, option: any) {
  const searchText = removeVNAccents(input).toLowerCase();
  const label = removeVNAccents((option?.label as string) ?? '').toLowerCase();
  const value = removeVNAccents((option?.value as string) ?? '').toLowerCase();
  return label.includes(searchText) || value.includes(searchText);
}


// return to Object
// not clear value === false
export const removeEmptyValue = (valuesSearch: object) => {
  return Object.fromEntries(
    Object.entries(valuesSearch).filter(([_, value]) => {
      if (value === false) {
        return true;
      } else {
        return !!value;
      }
    }),
  );
};